import { render, staticRenderFns } from "./TopicDirectory.vue?vue&type=template&id=20ecca71&"
import script from "./TopicDirectory.vue?vue&type=script&lang=js&"
export * from "./TopicDirectory.vue?vue&type=script&lang=js&"
import style0 from "./TopicDirectory.vue?vue&type=style&index=0&id=20ecca71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports